import React from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "./FilterComponentStyles";
import {useObserver} from "mobx-react-lite";
import {arrayAlphabeticalSort} from "../../../utils/helpers";
import {userTypes} from "../../../constants/constants";
const UserTypeFilter = ({
    allKey = "all",
    allowClear = false,
    hideTitle = false,
    showAll = true,
    showSearch = true,
    ...props
}) => {
    const {t} = useTranslation(["userTypes"]);

    return useObserver(() => (
        <React.Fragment>
            {!hideTitle && <h5>{t("fields.role", {ns: "common"})}</h5>}
            <SelectField
                allowClear={allowClear}
                showSearch={showSearch}
                filterOption={(input, option) => {
                    const children = option?.props?.children;
                    const childrenText = Array.isArray(children) ? children.join(" ") : children;
                    return (
                        childrenText?.toLowerCase()?.indexOf(input.toLowerCase()) >= 0 ||
                        option?.props?.value?.toLowerCase()?.indexOf(input.toLowerCase()) >= 0
                    );
                }}
                data-testid="userTypeSelect"
                {...props}
            >
                {showAll && (
                    <SelectField.Option value={allKey} data-testid="userTypeSelect_option">
                        {t("filters.all", {ns: "common"})} ({t("fields.role", {ns: "common"})})
                    </SelectField.Option>
                )}

                {arrayAlphabeticalSort([...userTypes], "value").map(userType => (
                    <SelectField.Option
                        key={userType.value}
                        value={userType.value}
                        data-testid="userTypeSelect_option"
                    >
                        {t(userType.translation_key, {ns: "userTypes"})}
                    </SelectField.Option>
                ))}
            </SelectField>
        </React.Fragment>
    ));
};

export default UserTypeFilter;
